var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.8 25 39.3 50.4l-82 280.8c-5.9 20.2-24.7 34.3-46.2 34.3H171.3c-21.5 0-40.3-14.1-46.2-34.3L43.2 82H24C10.7 82 0 71.3 0 58V24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm336 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineShop);
export default __webpack_public_path__ + "static/media/online-shop.68d9a8cd24864dd153fdb7e7ec6315c9.svg";
export { ForwardRef as ReactComponent };